// extracted by mini-css-extract-plugin
export default {"heading":"Contact_heading__KE+O3"};